export var ShareableItemType = /*#__PURE__*/ function(ShareableItemType) {
    ShareableItemType["SHAREABLE_ITEM_TYPE_UNKNOWN"] = "SHAREABLE_ITEM_TYPE_UNKNOWN";
    ShareableItemType["PRODUCT"] = "PRODUCT";
    ShareableItemType["BRAND"] = "BRAND";
    ShareableItemType["INVOICE"] = "INVOICE";
    ShareableItemType["BRAND_ORDER"] = "BRAND_ORDER";
    return ShareableItemType;
}({});
